import { render } from "./BaseRegSizeForm.vue?vue&type=template&id=5016f385&scoped=true"
import script from "./BaseRegSizeForm.vue?vue&type=script&lang=js"
export * from "./BaseRegSizeForm.vue?vue&type=script&lang=js"

import "./BaseRegSizeForm.vue?vue&type=style&index=0&id=5016f385&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5016f385"]])

export default __exports__